
/**
 * @ngdoc directive
 * @name articlesslideshow
 *
 * @description
 * Slideshow of articles
 */
module.directive('articlesslideshow', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '=',
            numberItems: '@',
            configKey: '@',
            displayProducts: '@?',
            shopLastItem: '@?'
        },
        controller: function ($rootScope, $scope, tools, cart, lodash, drupal) {
            $scope.tools = tools;

            $scope.content.field_products = [{}, {}, {}, {}];
            // expose site config
            $scope.configSite = $rootScope.config.site;

            if ($scope.displayProducts === 'true') {
                var blocks = $rootScope.config.site[$scope.configKey];
                if (blocks) {
                    drupal.getProducts().then(function(products) {
                        (products || []).forEach(function(product) {
                            if (product.sfid === blocks.produit_1) {
                                angular.copy(product, $scope.content.field_products[0]);
                            }
                            if (product.sfid === blocks.produit_2) {
                                angular.copy(product, $scope.content.field_products[1]);
                            }
                            if (product.sfid === blocks.produit_3) {
                                angular.copy(product, $scope.content.field_products[2]);
                            }
                            if (product.sfid === blocks.produit_4) {
                                angular.copy(product, $scope.content.field_products[3]);
                            }
                        });
                    });
                }
            }

            $scope.init = function() {
                // Set to first element in slideshow
                $scope.current = 0;

                if ($scope.displayProducts) {
                    // If shopLastItem to true, we remove last item to replace it by shop item
                    if ($scope.shopLastItem) {
                        $scope.slides = $scope.content.field_products.slice(0, $scope.numberItems - 1);
                    } else {
                        $scope.slides = $scope.content.field_products;
                    }
                } else {
                    $scope.slides = $scope.content.field_slides;
                }
            };
            $scope.init();

            $scope.setSlide = function (idx) {
                $scope.current = idx;
            };
            $scope.prev = function () {
                $scope.current = Math.max(0, $scope.current - 1);
            };
            $scope.next = function () {
                $scope.current = Math.min($scope.numberItems - 1, $scope.current + 1);
            };

            // check if product is in stock (with stock already in cart)
            $scope.inStock = function (product) {
                var myProduct = lodash.find(cart.products, {id: product.sfid});
                return product.stock - (myProduct ? myProduct.field_quantity : 0) > 0;
            };

            // add product to cart
            $scope.addToCart = function (product) {
                if (!product.pending) {
                    product.pending = true;
                    cart.addProduct(product).then(function () {
                        product.pending = false;
                        // TODO : add error handler
                    });
                }
            };
        },
        templateUrl: 'src/components/articlesslideshow/articlesslideshow.html'
    };
});
